(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-theniya-custom"] && !Shopify.designMode) return;
  try {
    
  // Quantity increase/decrease functions (global)
  window.increaseQuantity = function() {
    const input = document.getElementById('quantity');
    input.value = parseInt(input.value) + 1;
  }

  window.decreaseQuantity = function() {
    const input = document.getElementById('quantity');
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  }

  // Update variant when options change (global)
  window.updateVariant = function() {
    const selects = document.querySelectorAll('.variant-select');
    const selectedOptions = Array.from(selects).map(select => select.value);
    
    // Find matching variant
    const variants = window.productVariants || [];
    const matchingVariant = variants.find(variant => {
      return selectedOptions.every((option, index) => {
        return variant.options[index] === option;
      });
    });
    
    if (matchingVariant) {
      // Update hidden variant ID field
      document.getElementById('variant-id').value = matchingVariant.id;
      resetHolderGallery();
      
      // Update price with discount if promo is enabled
      const promoPrice = document.getElementById('promo-price');
      const buttonPrice = document.getElementById('button-price');
      const originalPrice = document.querySelector('.original-price');
      
      if (matchingVariant.price) {
        const basePrice = matchingVariant.price / 100;
        
        if (window.showPromo) {
          const discountMultiplier = 1 - (window.promoDiscountPercent / 100);
          const discountedPrice = (basePrice * discountMultiplier).toFixed(2);
          
          if (promoPrice) {
            promoPrice.textContent = '$' + discountedPrice;
          }
          if (buttonPrice) {
            buttonPrice.textContent = '$' + discountedPrice;
          }
          if (originalPrice) {
            originalPrice.textContent = '$' + basePrice.toFixed(2);
          }
        }
      }
    }
  }

  // Smooth scroll to newsletter form
  window.scrollToNewsletter = function(event) {
    event.preventDefault();
    event.stopPropagation();
    
    // Try multiple selectors to find the newsletter form
    const selectors = [
      '#newsletter-form',
      '.newsletter-form',
      '[id*="newsletter"]',
      '[class*="newsletter"]',
      'form[action*="contact"]',
      '.footer-newsletter',
      '#shopify-section-footer'
    ];
    
    let newsletterElement = null;
    for (const selector of selectors) {
      newsletterElement = document.querySelector(selector);
      if (newsletterElement) break;
    }
    
    if (newsletterElement) {
      const elementPosition = newsletterElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - 220; // Offset for fixed header
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      
      // Try to focus on email input after scrolling
      setTimeout(() => {
        const emailInput = newsletterElement.querySelector('input[type="email"]');
        if (emailInput) {
          emailInput.focus();
        }
      }, 800);
    } else {
      // Fallback: scroll to bottom of page
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }
  }

  // The holder gallery groups its clean shot and tote shot by stable filenames.
  function holderGalleryRoot() {
    return document.querySelector('.product-hero-section[data-pattern-gallery]');
  }

  function availableGalleryIndexes() {
    const root = holderGalleryRoot();
    const images = Array.from(document.querySelectorAll('.product-main-image'));
    if (!root) return images.map((image, index) => index);
    const pattern = root.querySelector('.variant-select')?.value;
    const groups = {
      'Gold Dots on Burgundy': ['Gold_Dots_on_Burgundy_Bottle_Holder.png', 'Cuticle_Oil_Holder_on_Black_Tote-1_'],
      'Gold Quatrefoil on White': ['Gold_quatrefoil_bottle_holder_on_white.png', 'Ribbed_cuticle_oil_holder_on_black_tote-2.png'],
      'Gold Dots on Black': ['Gold-Dot_Black_Bottle_Sleeve.png', 'Ribbed_cuticle_oil_holder_on_black_tote-3.png'],
      'Pastel Gold Stripe': ['Pastel_Gold_Stripe_Bottle_Holder.png', 'Ribbed_cuticle_holder_clipped_to_black_tote-4.png']
    };
    const filenames = groups[pattern];
    if (!filenames) return images.map((image, index) => index);
    return filenames.flatMap(filename => images.flatMap((image, index) =>
      (image.getAttribute('src') || '').includes(filename) ? [index] : []));
  }

  function resetHolderGallery() {
    if (!holderGalleryRoot()) return;
    const available = availableGalleryIndexes();
    if (!available.length) return;
    currentImageIndex = available[0];
    updateGalleryDisplay();
  }

  // Image Gallery Functions
  let currentImageIndex = 0;
  let autoRotateInterval;
  let userPaused = false;

  // Make selectImage globally accessible
  window.selectImage = function(index) {
    // Pause auto-rotate when user manually selects
    userPaused = true;
    if (autoRotateInterval) {
      clearInterval(autoRotateInterval);
    }

    if (!availableGalleryIndexes().includes(index)) return;
    currentImageIndex = index;
    updateGalleryDisplay();

    // Resume auto-rotate after 15 seconds of inactivity
    setTimeout(() => {
      if (userPaused) {
        userPaused = false;
        startAutoRotate();
      }
    }, 15000);
  }

  function updateGalleryDisplay() {
    const images = document.querySelectorAll('.product-main-image');
    const thumbnails = document.querySelectorAll('.thumbnail-item');

    const allowed = availableGalleryIndexes();

    // Update main images
    images.forEach((img, index) => {
      if (index === currentImageIndex) {
        img.classList.add('active');
      } else {
        img.classList.remove('active');
      }
    });

    // Update thumbnails
    thumbnails.forEach((thumb, index) => {
      if (holderGalleryRoot()) thumb.style.display = allowed.includes(index) ? '' : 'none';
      if (index === currentImageIndex) {
        thumb.classList.add('active');
      } else {
        thumb.classList.remove('active');
      }
    });
  }

  function nextImage() {
    const images = document.querySelectorAll('.product-main-image');
    if (images.length > 1) {
      const available = availableGalleryIndexes();
      if (!available.length) return;
      const position = available.indexOf(currentImageIndex);
      currentImageIndex = available[(position + 1) % available.length];
      updateGalleryDisplay();
    }
  }

  function startAutoRotate() {
    const images = document.querySelectorAll('.product-main-image');
    if (images.length > 1 && !userPaused) {
      autoRotateInterval = setInterval(nextImage, 5000); // Change every 5 seconds
    }
  }

  // Smooth scroll to reviews section
  window.scrollToReviews = function(event) {
    event.preventDefault();
    const reviewsSection = document.getElementById('judgeme_product_reviews');
    if (reviewsSection) {
      // Get the position of the reviews section
      const elementPosition = reviewsSection.getBoundingClientRect().top + window.pageYOffset;
      // Offset for fixed header (adjust this value as needed: 100-150px typical)
      const offsetPosition = elementPosition - 190;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  // Update rating display from Judge.me data
  function updateRatingDisplay() {
    const reviewWidget = document.querySelector('.jdgm-rev-widg');
    const ratingTextElement = document.getElementById('custom-rating-text');
    const ratingWrapper = document.getElementById('rating-wrapper');
    
    if (reviewWidget && ratingTextElement && ratingWrapper) {
      const avgRating = reviewWidget.getAttribute('data-average-rating');
      const numReviews = reviewWidget.getAttribute('data-number-of-reviews');
      
      if (avgRating && numReviews && parseInt(numReviews) > 0) {
        ratingTextElement.textContent = `${avgRating} (${numReviews} reviews)`;
        ratingWrapper.style.display = 'block';
      } else {
        ratingWrapper.style.display = 'none';
      }
    }
  }

  // Initialize gallery and rating display on page load
  document.addEventListener('DOMContentLoaded', function() {
    resetHolderGallery();
    startAutoRotate();
    
    // Wait for Judge.me widget to load, then update rating
    const checkJudgeme = setInterval(function() {
      const widget = document.querySelector('.jdgm-rev-widg');
      if (widget && widget.getAttribute('data-average-rating')) {
        updateRatingDisplay();
        clearInterval(checkJudgeme);
      }
    }, 100);
    
    // Timeout after 5 seconds if Judge.me doesn't load
    setTimeout(function() {
      clearInterval(checkJudgeme);
    }, 5000);
  });

  } catch(e) { console.error(e); }
})();
})();
